import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const MultipleUnitsNavigatorRoot = styled.nav({});

export const Item = styled.span(props => ({
    marginRight: theme(props).size(1),
}));

export const Item2 = styled.span(props => ({
    marginRight: theme(props).size(4),
}));
